import React, { useState } from "react";
import Header from "./components/Header";
import Scoreboard from "./components/Scoreboard";
import CardGrid from "./components/CardGrid";
import "./styles.css";

function App() {
  const [score, setScore] = useState(0);
  const [bestScore, setBestScore] = useState(0);

  const updateScore = (newScore) => {
    setScore(newScore);
    if (newScore > bestScore) setBestScore(newScore);
  };

  return (
    <div className="app">
      <Header />
      <Scoreboard score={score} bestScore={bestScore} />
      <CardGrid updateScore={updateScore} />
    </div>
  );
}

export default App;
